import { DiagnosePanel as Widget, type DiagnosePanelProps } from "@k8s-dashboard/diagnose-widget";
import { agentTransport, diagnoseTransport } from "@/api/diagnose";

/**
 * 패키지 위젯에 이 대시보드의 통로만 붙입니다. (k8sdiag ADR-0005)
 * 위젯은 BFF 경로도 토큰도 알지 않습니다 — 아는 쪽은 여기 하나입니다.
 */
export function DiagnosePanel(props: Omit<DiagnosePanelProps, "transport">) {
  return <Widget {...props} transport={diagnoseTransport} agentTransport={agentTransport} />;
}
